import OSchedule from './o-schedule';

export default OSchedule;